import { Router } from "express";

import { classWithdrawalController } from "../controllers/class-withdrawal-controller";
import { authenticate, createRateLimit } from "../middleware/auth-middleware";
import { requireRole } from "../middleware/role-middleware";
import { uploadMiddleware } from "../middleware/upload-middleware";

const router = Router();

// Environment-aware rate limiting
const generalRateLimit = createRateLimit.general();

/**
 * Student Class Withdrawal Routes
 */

/**
 * @route   POST /api/v1/student/classes/:classId/withdraw
 * @desc    Create a class withdrawal request with reason and image attachments
 * @access  Private (Student)
 */
router.post(
  "/student/classes/:classId/withdraw",
  authenticate,
  requireRole(["student"]),
  generalRateLimit,
  uploadMiddleware.array("attachments", 10), // Allow up to 10 image attachments
  (req, res) =>
    classWithdrawalController.createWithdrawalRequest(req as any, res),
);

/**
 * @route   GET /api/v1/student/withdrawal-requests
 * @desc    Get student's withdrawal requests
 * @access  Private (Student)
 */
router.get(
  "/student/withdrawal-requests",
  authenticate,
  requireRole(["student"]),
  generalRateLimit,
  (req, res) =>
    classWithdrawalController.getStudentWithdrawalRequests(req as any, res),
);

/**
 * Teacher Class Withdrawal Routes
 */

/**
 * @route   GET /api/v1/teacher/withdrawal-requests
 * @desc    Get withdrawal requests for teacher's classes
 * @access  Private (Teacher)
 */
router.get(
  "/teacher/withdrawal-requests",
  authenticate,
  requireRole(["teacher"]),
  generalRateLimit,
  (req, res) =>
    classWithdrawalController.getTeacherWithdrawalRequests(req as any, res),
);

/**
 * School/Teacher Approval Routes
 */

/**
 * @route   PUT /api/v1/school/withdrawal-requests/:id/approve
 * @desc    Approve withdrawal request
 * @access  Private (Teacher, School Admin)
 */
router.put(
  "/school/withdrawal-requests/:id/approve",
  authenticate,
  requireRole(["teacher", "school"]),
  generalRateLimit,
  (req, res) =>
    classWithdrawalController.approveWithdrawalRequest(req as any, res),
);

/**
 * @route   PUT /api/v1/school/withdrawal-requests/:id/reject
 * @desc    Reject withdrawal request
 * @access  Private (Teacher, School Admin)
 */
router.put(
  "/school/withdrawal-requests/:id/reject",
  authenticate,
  requireRole(["teacher", "school"]),
  generalRateLimit,
  (req, res) =>
    classWithdrawalController.rejectWithdrawalRequest(req as any, res),
);

export default router;
